// Pulls per-day focus counts from the server (/health/focus/by-day) and feeds
// them into the focus ledger overlay, so Activity/streak views agree across
// devices. Refreshes on mount, on reconnect, on tab return, and (throttled)
// after local focus events; setServerFocusDays only emits when data changed,
// which keeps the focus_log_changed listener loop-safe.
import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext.jsx';
import { setServerFocusDays } from '../lib/focusLog.js';

export default function FocusDaysSync() {
  const { token, apiFetch } = useAuth();
  const lastRef = useRef(0);

  useEffect(() => {
    if (!token || token === 'local') return;
    let alive = true;

    const load = async (force = false) => {
      if (!alive) return;
      const now = Date.now();
      if (!force && now - lastRef.current < 15000) return; // throttle
      lastRef.current = now;
      try {
        let tz = 'UTC';
        try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch { /* ignore */ }
        const r = await apiFetch('/health/focus/by-day?days=120&tz=' + encodeURIComponent(tz));
        if (!r || !r.ok) return;
        const d = await r.json().catch(() => null);
        if (!alive || !d || !Array.isArray(d.days)) return;
        const map = {};
        for (const row of d.days) if (row && row.day) map[row.day] = row.count || 0;
        setServerFocusDays(map);
      } catch { /* offline — леджер прикрывает */ }
    };

    load(true);
    const onUp = () => load(true);
    const onVis = () => { if (!document.hidden) load(); };
    const onFocusEvt = () => setTimeout(() => load(), 4000); // дать POST'у долететь
    window.addEventListener('online', onUp);
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('focus_log_changed', onFocusEvt);
    return () => {
      alive = false;
      window.removeEventListener('online', onUp);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('focus_log_changed', onFocusEvt);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return null;
}
